import React, { useContext } from 'react';
import { Button } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import styles from 'components/brikks/home/MovingOut/components/MovingOutModal/components/MovingOutInfo/components/Tabs/styles.module.scss';
import { MovingOutModalContext } from 'components/brikks/home/MovingOut/components/MovingOutModal/index';

export const Tabs = ({ activeTab, setActiveTab }) => {
  const { setActiveMenu } = useContext(MovingOutModalContext);

  const handleChangeTab = (tab) => {
    if (tab === 'checkList') {
      setActiveTab(tab);
      setActiveMenu('terminateAgreements');
    } else {
      setActiveTab(tab);
      setActiveMenu('');
    }
  };
  return (
    <Button.Group className={styles.tabs}>
      <Button
        className={activeTab === 'checkList' ? styles.button : ''}
        positive={activeTab === 'checkList'}
        onClick={() => handleChangeTab('checkList')}
      >
        <FormattedMessage id="checkList" />
      </Button>
      <Button.Or className={styles.or} />
      <Button
        className={activeTab === 'generalInfo' ? styles.button : ''}
        positive={activeTab === 'generalInfo'}
        onClick={() => handleChangeTab('generalInfo')}
      >
        <FormattedMessage id="generalInfo" />
      </Button>
    </Button.Group>
  );
};
